/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VolumeRouteImport } from './routes/volume'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as PotsRouteImport } from './routes/pots'
import { Route as OperatorsRouteImport } from './routes/operators'
import { Route as JurisdictionsRouteImport } from './routes/jurisdictions'
import { Route as AuditLogRouteImport } from './routes/audit-log'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TierPolicyIndexRouteImport } from './routes/tier-policy/index'
import { Route as PlayersIndexRouteImport } from './routes/players/index'
import { Route as OperationsIndexRouteImport } from './routes/operations/index'
import { Route as MlroIndexRouteImport } from './routes/mlro/index'
import { Route as TierPolicyIdRouteImport } from './routes/tier-policy/$id'
import { Route as PlayersAddressRouteImport } from './routes/players/$address'
import { Route as OperationsIdRouteImport } from './routes/operations/$id'
import { Route as MlroClosuresRouteImport } from './routes/mlro/closures'
import { Route as MlroAlertsRouteImport } from './routes/mlro/alerts'
import { Route as MlroSybilIndexRouteImport } from './routes/mlro/sybil/index'
import { Route as MlroCasesIndexRouteImport } from './routes/mlro/cases/index'
import { Route as MlroSybilIdRouteImport } from './routes/mlro/sybil/$id'
import { Route as MlroCasesIdRouteImport } from './routes/mlro/cases/$id'

const VolumeRoute = VolumeRouteImport.update({
  id: '/volume',
  path: '/volume',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsRoute = ReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => rootRouteImport,
} as any)
const PotsRoute = PotsRouteImport.update({
  id: '/pots',
  path: '/pots',
  getParentRoute: () => rootRouteImport,
} as any)
const OperatorsRoute = OperatorsRouteImport.update({
  id: '/operators',
  path: '/operators',
  getParentRoute: () => rootRouteImport,
} as any)
const JurisdictionsRoute = JurisdictionsRouteImport.update({
  id: '/jurisdictions',
  path: '/jurisdictions',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogRoute = AuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TierPolicyIndexRoute = TierPolicyIndexRouteImport.update({
  id: '/tier-policy/',
  path: '/tier-policy/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayersIndexRoute = PlayersIndexRouteImport.update({
  id: '/players/',
  path: '/players/',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsIndexRoute = OperationsIndexRouteImport.update({
  id: '/operations/',
  path: '/operations/',
  getParentRoute: () => rootRouteImport,
} as any)
const MlroIndexRoute = MlroIndexRouteImport.update({
  id: '/mlro/',
  path: '/mlro/',
  getParentRoute: () => rootRouteImport,
} as any)
const TierPolicyIdRoute = TierPolicyIdRouteImport.update({
  id: '/tier-policy/$id',
  path: '/tier-policy/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayersAddressRoute = PlayersAddressRouteImport.update({
  id: '/players/$address',
  path: '/players/$address',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsIdRoute = OperationsIdRouteImport.update({
  id: '/operations/$id',
  path: '/operations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MlroClosuresRoute = MlroClosuresRouteImport.update({
  id: '/mlro/closures',
  path: '/mlro/closures',
  getParentRoute: () => rootRouteImport,
} as any)
const MlroAlertsRoute = MlroAlertsRouteImport.update({
  id: '/mlro/alerts',
  path: '/mlro/alerts',
  getParentRoute: () => rootRouteImport,
} as any)
const MlroSybilIndexRoute = MlroSybilIndexRouteImport.update({
  id: '/mlro/sybil/',
  path: '/mlro/sybil/',
  getParentRoute: () => rootRouteImport,
} as any)
const MlroCasesIndexRoute = MlroCasesIndexRouteImport.update({
  id: '/mlro/cases/',
  path: '/mlro/cases/',
  getParentRoute: () => rootRouteImport,
} as any)
const MlroSybilIdRoute = MlroSybilIdRouteImport.update({
  id: '/mlro/sybil/$id',
  path: '/mlro/sybil/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MlroCasesIdRoute = MlroCasesIdRouteImport.update({
  id: '/mlro/cases/$id',
  path: '/mlro/cases/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit-log': typeof AuditLogRoute
  '/jurisdictions': typeof JurisdictionsRoute
  '/operators': typeof OperatorsRoute
  '/pots': typeof PotsRoute
  '/referrals': typeof ReferralsRoute
  '/settings': typeof SettingsRoute
  '/volume': typeof VolumeRoute
  '/mlro/alerts': typeof MlroAlertsRoute
  '/mlro/closures': typeof MlroClosuresRoute
  '/operations/$id': typeof OperationsIdRoute
  '/players/$address': typeof PlayersAddressRoute
  '/tier-policy/$id': typeof TierPolicyIdRoute
  '/mlro/': typeof MlroIndexRoute
  '/operations/': typeof OperationsIndexRoute
  '/players/': typeof PlayersIndexRoute
  '/tier-policy/': typeof TierPolicyIndexRoute
  '/mlro/cases/$id': typeof MlroCasesIdRoute
  '/mlro/sybil/$id': typeof MlroSybilIdRoute
  '/mlro/cases/': typeof MlroCasesIndexRoute
  '/mlro/sybil/': typeof MlroSybilIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit-log': typeof AuditLogRoute
  '/jurisdictions': typeof JurisdictionsRoute
  '/operators': typeof OperatorsRoute
  '/pots': typeof PotsRoute
  '/referrals': typeof ReferralsRoute
  '/settings': typeof SettingsRoute
  '/volume': typeof VolumeRoute
  '/mlro/alerts': typeof MlroAlertsRoute
  '/mlro/closures': typeof MlroClosuresRoute
  '/operations/$id': typeof OperationsIdRoute
  '/players/$address': typeof PlayersAddressRoute
  '/tier-policy/$id': typeof TierPolicyIdRoute
  '/mlro': typeof MlroIndexRoute
  '/operations': typeof OperationsIndexRoute
  '/players': typeof PlayersIndexRoute
  '/tier-policy': typeof TierPolicyIndexRoute
  '/mlro/cases/$id': typeof MlroCasesIdRoute
  '/mlro/sybil/$id': typeof MlroSybilIdRoute
  '/mlro/cases': typeof MlroCasesIndexRoute
  '/mlro/sybil': typeof MlroSybilIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit-log': typeof AuditLogRoute
  '/jurisdictions': typeof JurisdictionsRoute
  '/operators': typeof OperatorsRoute
  '/pots': typeof PotsRoute
  '/referrals': typeof ReferralsRoute
  '/settings': typeof SettingsRoute
  '/volume': typeof VolumeRoute
  '/mlro/alerts': typeof MlroAlertsRoute
  '/mlro/closures': typeof MlroClosuresRoute
  '/operations/$id': typeof OperationsIdRoute
  '/players/$address': typeof PlayersAddressRoute
  '/tier-policy/$id': typeof TierPolicyIdRoute
  '/mlro/': typeof MlroIndexRoute
  '/operations/': typeof OperationsIndexRoute
  '/players/': typeof PlayersIndexRoute
  '/tier-policy/': typeof TierPolicyIndexRoute
  '/mlro/cases/$id': typeof MlroCasesIdRoute
  '/mlro/sybil/$id': typeof MlroSybilIdRoute
  '/mlro/cases/': typeof MlroCasesIndexRoute
  '/mlro/sybil/': typeof MlroSybilIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit-log'
    | '/jurisdictions'
    | '/operators'
    | '/pots'
    | '/referrals'
    | '/settings'
    | '/volume'
    | '/mlro/alerts'
    | '/mlro/closures'
    | '/operations/$id'
    | '/players/$address'
    | '/tier-policy/$id'
    | '/mlro/'
    | '/operations/'
    | '/players/'
    | '/tier-policy/'
    | '/mlro/cases/$id'
    | '/mlro/sybil/$id'
    | '/mlro/cases/'
    | '/mlro/sybil/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit-log'
    | '/jurisdictions'
    | '/operators'
    | '/pots'
    | '/referrals'
    | '/settings'
    | '/volume'
    | '/mlro/alerts'
    | '/mlro/closures'
    | '/operations/$id'
    | '/players/$address'
    | '/tier-policy/$id'
    | '/mlro'
    | '/operations'
    | '/players'
    | '/tier-policy'
    | '/mlro/cases/$id'
    | '/mlro/sybil/$id'
    | '/mlro/cases'
    | '/mlro/sybil'
  id:
    | '__root__'
    | '/'
    | '/audit-log'
    | '/jurisdictions'
    | '/operators'
    | '/pots'
    | '/referrals'
    | '/settings'
    | '/volume'
    | '/mlro/alerts'
    | '/mlro/closures'
    | '/operations/$id'
    | '/players/$address'
    | '/tier-policy/$id'
    | '/mlro/'
    | '/operations/'
    | '/players/'
    | '/tier-policy/'
    | '/mlro/cases/$id'
    | '/mlro/sybil/$id'
    | '/mlro/cases/'
    | '/mlro/sybil/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditLogRoute: typeof AuditLogRoute
  JurisdictionsRoute: typeof JurisdictionsRoute
  OperatorsRoute: typeof OperatorsRoute
  PotsRoute: typeof PotsRoute
  ReferralsRoute: typeof ReferralsRoute
  SettingsRoute: typeof SettingsRoute
  VolumeRoute: typeof VolumeRoute
  MlroAlertsRoute: typeof MlroAlertsRoute
  MlroClosuresRoute: typeof MlroClosuresRoute
  OperationsIdRoute: typeof OperationsIdRoute
  PlayersAddressRoute: typeof PlayersAddressRoute
  TierPolicyIdRoute: typeof TierPolicyIdRoute
  MlroIndexRoute: typeof MlroIndexRoute
  OperationsIndexRoute: typeof OperationsIndexRoute
  PlayersIndexRoute: typeof PlayersIndexRoute
  TierPolicyIndexRoute: typeof TierPolicyIndexRoute
  MlroCasesIdRoute: typeof MlroCasesIdRoute
  MlroSybilIdRoute: typeof MlroSybilIdRoute
  MlroCasesIndexRoute: typeof MlroCasesIndexRoute
  MlroSybilIndexRoute: typeof MlroSybilIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/volume': {
      id: '/volume'
      path: '/volume'
      fullPath: '/volume'
      preLoaderRoute: typeof VolumeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals': {
      id: '/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof ReferralsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pots': {
      id: '/pots'
      path: '/pots'
      fullPath: '/pots'
      preLoaderRoute: typeof PotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operators': {
      id: '/operators'
      path: '/operators'
      fullPath: '/operators'
      preLoaderRoute: typeof OperatorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jurisdictions': {
      id: '/jurisdictions'
      path: '/jurisdictions'
      fullPath: '/jurisdictions'
      preLoaderRoute: typeof JurisdictionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-log': {
      id: '/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tier-policy/': {
      id: '/tier-policy/'
      path: '/tier-policy'
      fullPath: '/tier-policy/'
      preLoaderRoute: typeof TierPolicyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/players/': {
      id: '/players/'
      path: '/players'
      fullPath: '/players/'
      preLoaderRoute: typeof PlayersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations/': {
      id: '/operations/'
      path: '/operations'
      fullPath: '/operations/'
      preLoaderRoute: typeof OperationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mlro/': {
      id: '/mlro/'
      path: '/mlro'
      fullPath: '/mlro/'
      preLoaderRoute: typeof MlroIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tier-policy/$id': {
      id: '/tier-policy/$id'
      path: '/tier-policy/$id'
      fullPath: '/tier-policy/$id'
      preLoaderRoute: typeof TierPolicyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/players/$address': {
      id: '/players/$address'
      path: '/players/$address'
      fullPath: '/players/$address'
      preLoaderRoute: typeof PlayersAddressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations/$id': {
      id: '/operations/$id'
      path: '/operations/$id'
      fullPath: '/operations/$id'
      preLoaderRoute: typeof OperationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mlro/closures': {
      id: '/mlro/closures'
      path: '/mlro/closures'
      fullPath: '/mlro/closures'
      preLoaderRoute: typeof MlroClosuresRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mlro/alerts': {
      id: '/mlro/alerts'
      path: '/mlro/alerts'
      fullPath: '/mlro/alerts'
      preLoaderRoute: typeof MlroAlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mlro/sybil/': {
      id: '/mlro/sybil/'
      path: '/mlro/sybil'
      fullPath: '/mlro/sybil/'
      preLoaderRoute: typeof MlroSybilIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mlro/cases/': {
      id: '/mlro/cases/'
      path: '/mlro/cases'
      fullPath: '/mlro/cases/'
      preLoaderRoute: typeof MlroCasesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mlro/sybil/$id': {
      id: '/mlro/sybil/$id'
      path: '/mlro/sybil/$id'
      fullPath: '/mlro/sybil/$id'
      preLoaderRoute: typeof MlroSybilIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mlro/cases/$id': {
      id: '/mlro/cases/$id'
      path: '/mlro/cases/$id'
      fullPath: '/mlro/cases/$id'
      preLoaderRoute: typeof MlroCasesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditLogRoute: AuditLogRoute,
  JurisdictionsRoute: JurisdictionsRoute,
  OperatorsRoute: OperatorsRoute,
  PotsRoute: PotsRoute,
  ReferralsRoute: ReferralsRoute,
  SettingsRoute: SettingsRoute,
  VolumeRoute: VolumeRoute,
  MlroAlertsRoute: MlroAlertsRoute,
  MlroClosuresRoute: MlroClosuresRoute,
  OperationsIdRoute: OperationsIdRoute,
  PlayersAddressRoute: PlayersAddressRoute,
  TierPolicyIdRoute: TierPolicyIdRoute,
  MlroIndexRoute: MlroIndexRoute,
  OperationsIndexRoute: OperationsIndexRoute,
  PlayersIndexRoute: PlayersIndexRoute,
  TierPolicyIndexRoute: TierPolicyIndexRoute,
  MlroCasesIdRoute: MlroCasesIdRoute,
  MlroSybilIdRoute: MlroSybilIdRoute,
  MlroCasesIndexRoute: MlroCasesIndexRoute,
  MlroSybilIndexRoute: MlroSybilIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
